export interface PastedAreaRow {
  description: string;
  area: number | null;
  eyrBuilt: number | null;
}

export function parseAreaNumber(raw: string): number | null {
  const cleaned = raw.replace(/m²|m2/gi, "").replace(/,/g, "").trim();
  if (!cleaned) return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
}

export function isMultiCellPaste(text: string): boolean {
  return text.includes("\t") || text.includes("\n") || text.includes("\r");
}

export function parseClipboardRows(text: string): PastedAreaRow[] {
  const lines = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n").split("\n");
  const rows: PastedAreaRow[] = [];
  for (const line of lines) {
    if (!line.trim()) continue;
    const cells = line.split("\t");
    const description = (cells[0] ?? "").trim();
    const area = cells[1] != null ? parseAreaNumber(cells[1]) : null;
    const eyrBuilt = cells[2] != null && cells[2].trim() !== "" ? parseAreaNumber(cells[2]) : null;
    rows.push({ description, area, eyrBuilt });
  }
  return rows;
}
